import React from "react";

export default function OffCanvas({ isOpen, onClose }) {
  return (
    <>
      <div className={`offcanvas-overlay${isOpen ? " open" : ""}`} onClick={onClose}></div>
      <div className={`premium-offcanvas${isOpen ? " open" : ""}`}>
        <div className="offcanvas-top">
          <span className="offcanvas-logo">Continental BioBank</span>
          <button className="offcanvas-close" onClick={onClose} aria-label="Close menu">
            <svg width="24" height="24" viewBox="0 0 37 38" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.19141 9.80762L27.5762 28.1924" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M9.19141 28.1924L27.5762 9.80761" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
        <div className="offcanvas-body">
          <h3 className="offcanvas-title">About the Continental Bio Bank</h3>
          <p>A Continental Bio Bank stores blood and other human samples—like urine, tissue, or DNA—along with coded health information to help researchers better understand, prevent, and treat diseases.</p>

          <div className="offcanvas-contact">
            <h4>Information</h4>
            <ul>
              <li><a href="tel:+914069286747">+91 40 69286747</a></li>
              <li><a href="mailto:info@resonancebiobank.com">info@resonancebiobank.com</a></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
